<template>
  <footer>
    <div class="footer">
      <div class="inner">
        <div class="strap">
          <!-- ??? -->
          CT Butterfield &amp; Sons Ltd (Butterfields), Funeral Directors of Rotherham, since 1874. One of the largest independent family Funeral Directors in South Yorkshire. We have a Funeral Home, Office and Memorial Showroom in Swinton, Rotherham and an additional Funeral Home and Office in Kimberworth, Rotherham. We are also proud to serve all customers throughout Rotherham, Doncaster, Barnsley and Sheffield.

        </div>
        <a
          href="http://www.butterfields-memorial-masons.com/"
          target="_blank"
          rel="noreferrer"
          class="sister"
        >Please visit our Memorial Mason website</a>
        <div class="legal">
          &copy; {{(new Date()).getFullYear()}} Butterfields |
          <router-link
            :to="'/' + $store.state.privacy.url"
            v-if="$store.state.privacy"
          >{{$store.state.privacy.name}}</router-link><br />Website designed &amp; developed by
          <a
            href="https://chameleoncreative.marketing"
            rel="noreferrer"
            target="_blank"
          >Chameleon Creative</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter"
}
</script>

<style scoped>
.footer {
  background: #acb62b;
  color: white;
  text-align: center;
  padding: 2rem;
  display: table;
  width: 100%;
  position: relative;
}

.legal {
  clear: both;
  padding-top: 2rem;
}

.strap {
  font-family: "Roboto Slab", Georgia, "Times New Roman", Times, serif;
  font-size: 2rem;
  opacity: 0.7;
  padding: 2rem;
  max-width: 115rem;
  margin: auto;
}

.sister {
  position: absolute;
  right: 3%;
  bottom: 0;
  background: #8d9d9e;
  color: white;
  padding: 10px 30px;
  display: inline-block;
  transition: all 0.2s;
}

.sister:hover {
  filter: brightness(0.95);
  padding-bottom: 20px;
}
@media screen and (max-width: 1070px) {
  .footer {
    padding-bottom: 7rem;
  }
  .sister {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 500px) {
  .sister {
    left: 10%;
    width: 80%;
    transform: none;
  }
}
</style>
